import React, { Component } from "react";
import TopBar from "../__shared__/TopBar";
import SearchBar from "./SearchBar";
import "./styles.css";
import ProfileMenu from "../__shared__/ProfileMenu";
import { getUserPatientsMetadata, getNotifications } from "./helpers";
import { connect } from "react-redux";
import {
    resetCreatePlanShard,
    setCurrentPatientUUID,
    setCurrentPlanUUID,
    setCurrentTreatmentPlan,
    setCurrentVisitUUID,
    setFreehandPlan,
    setPlanCreationStepMetaData,
    setUploadState,
} from "../CreateTPlan_1Upload/actions";
import {
    EMPTY_STRING,
    loginReducerFlags,
    stepMetaData,
    stepPath,
    stepNumber,
    SUCCESS,
    clientErrorMessages,
    freehandStepMetaData,
} from "../../constants";
import { Link, withRouter } from "react-router-dom";
import { getPlan } from "../CreateTPlan_1Upload/helpers";
import { uploadStates } from "../CreateTPlan_1Upload/constants";
import { lockedErrorMessage } from "./constants";
import { setFlag } from "../Login/actions";
import { resetImageViewerShard } from "../../redux/image_viewer/actions";
import PropTypes from "prop-types";
import { setErrorState } from "../../redux/error_banner/actions";
import { rootStore } from "../../redux/store";
import DownloadSelectCard from "../__shared__/DownloadSelectCard";
import * as TreatmentPlan from "../../helpers/tplan/tplan";
import {
    addPendoTracking,
    getFreehandWorkflowAdjustedStep,
} from "../../helpers/helpers";
import ProgressBar from "./ProgressBar";
import {
    acquirePlanLock,
    checkPlanLocked,
    checkSharedPatient,
    releasePlanLock,
} from "../../helpers/backend_api";
import { setInstitutionUsersList } from "./actions";
import { getInstitutionUsers } from "../../helpers/backend_api";
import { filterAvendaHelperAccounts } from "../__shared__/Sidebar/helpers";
import { trackingEventNames } from "../../helpers/pendo_constants";
import ChangeNotificationModal from "../__shared__/ChangeNotificationModal";
import { getNotificationList } from "../__shared__/ChangeNotificationModal/helpers";
import UnfoldLogo from "../../ui/logos/UnfoldLogo";
import PatientList from "./PatientList";
import PlusIcon from "../../ui/icons/PlusIcon";
import Button from "../../ui/Button";

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientsFetchedData: [],
            loadComplete: false,
            loadFailed: false,
            toggleChangeNotification: false,
            notifications: null,
            plan: null,
        };

        this.handleResumePlan = this.handleResumePlan.bind(this);
        this.setPlanInShard = this.setPlanInShard.bind(this);
        this.getUserPatientsMetadataWrapper =
            this.getUserPatientsMetadataWrapper.bind(this);
        this.handleGetInstituionUsers =
            this.handleGetInstituionUsers.bind(this);
        this.showDownloadCard = this.showDownloadCard.bind(this);
        this.canAcquirePlanLock = this.canAcquirePlanLock.bind(this);
        this.handleNotifications = this.handleNotifications.bind(this);
        this.checkNotification = this.checkNotification.bind(this);
        this.resumePlan = this.resumePlan.bind(this);
        this.handleAddPatient = this.handleAddPatient.bind(this);
    }

    async componentDidMount() {
        if (this.props.planuuid) {
            await releasePlanLock({
                token: this.props.authToken,
                useruuid: this.props.useruuid,
                planuuid: this.props.planuuid,
            });
        }
        this.props.resetCreatePlanShard();
        this.props.resetImageViewerShard();
        this.getUserPatientsMetadataWrapper();
        this.handleGetInstituionUsers();
    }

    getUserPatientsMetadataWrapper() {
        getUserPatientsMetadata({
            useruuid: this.props.useruuid,
            token: this.props.authToken,
        }).then((result) => {
            if (result && result.status === SUCCESS) {
                this.setState({
                    // API returns null plansMetadata for users with no patients
                    // keep this an array so react-table doesn't crash.
                    patientsFetchedData: result.plansMetadata ?? [],
                    loadComplete: true,
                });
            } else {
                this.setState({
                    loadFailed: true,
                });
            }
        });
    }

    handleGetInstituionUsers() {
        if (!this.props.userData?.institutionID) return;

        getInstitutionUsers({
            userInstitutionID: this.props.userData?.institutionID,
            authToken: this.props.authToken,
        }).then((resp) => {
            if (resp?.userList?.length > 0) {
                const unfilteredDrList = resp.userList
                    .filter(
                        (doctor) => doctor.uuid !== this.props.userData.uuid
                    )
                    .map((doctor) => ({
                        firstName: doctor.firstName,
                        lastName: doctor.lastName,
                        uuid: doctor.uuid,
                        email: doctor.email,
                    }));
                const filteredInstitutionUsersList = filterAvendaHelperAccounts(
                    unfilteredDrList,
                    this.props.userData
                );
                this.props.setInstitutionUsersList(
                    filteredInstitutionUsersList
                );
            }
        });
    }

    async setPlanInShard(patientuuid, planuuid) {
        let scope = this;
        let plan;
        await getPlan(this.props.authToken, patientuuid, planuuid)
            .then((payload) => {
                return payload.json();
            })
            .then((json) => {
                plan = json.payload.plan;
                scope.props.setCurrentTreatmentPlan(plan);
            })
            .catch(() => {
                rootStore.dispatch(
                    setErrorState(
                        true,
                        clientErrorMessages.TPLAN_RETRIEVE_FAILED
                    )
                );
            });
        return plan;
    }

    canAcquirePlanLock(checkPlanLockedResponse) {
        return (
            checkPlanLockedResponse.status === SUCCESS &&
            (!checkPlanLockedResponse.planLocked ||
                (checkPlanLockedResponse.planLocked &&
                    checkPlanLockedResponse.lockHolderUserUuid ===
                        this.props.useruuid))
        );
    }

    /**
     * btnParams
     * @property {string} planId - planUuid
     * @property {string} patientId - patientUuid
     * @property {string} visitId - visitUuid
     * @property {number} planStepPath - number for plan step
     * @property {bool} flagState - state to be set for planCompleted
     */
    async handleResumePlan(btnParams) {
        const checkSharedPatientResponse = await checkSharedPatient({
            patientuuid: btnParams.patientId,
            token: this.props.authToken,
        });

        if (!checkSharedPatientResponse) {
            this.setPlanShardBeforeResume(btnParams);
            return;
        }

        const checkPlanLockedResponse = await checkPlanLocked({
            token: this.props.authToken,
            planuuid: btnParams.planId,
        });

        if (this.canAcquirePlanLock(checkPlanLockedResponse)) {
            await acquirePlanLock({
                token: this.props.authToken,
                planuuid: btnParams.planId,
                useruuid: this.props.useruuid,
            });
            this.setPlanShardBeforeResume(btnParams);
        } else {
            window.location.reload();
            rootStore.dispatch(setErrorState(true, lockedErrorMessage));
        }
    }

    setPlanShardBeforeResume(btnParams) {
        //set redux shard
        this.props.setCurrentVisitUUID(btnParams.visitId);
        this.props.setCurrentPatientUUID(btnParams.patientId);
        this.props.setCurrentPlanUUID(btnParams.planId);
        this.setPlanInShard(btnParams.patientId, btnParams.planId).then(
            (plan) => {
                this.props.setFlag({
                    flagId: loginReducerFlags.PLAN_COMPLETED,
                    newFlagState: btnParams.flagState,
                });
                this.props.setUploadState(0, uploadStates.COMPLETE);

                if (TreatmentPlan.isMRIOnly(plan)) {
                    let freehandPathStep = getFreehandWorkflowAdjustedStep(
                        btnParams.planStepPath
                    );
                    this.props.setPlanCreationStepMetaData(
                        freehandStepMetaData[parseInt(freehandPathStep)]
                    );
                    this.props.setFreehandPlan(true);
                } else {
                    this.props.setPlanCreationStepMetaData(
                        stepMetaData[btnParams.planStepPath]
                    );
                    this.props.setFreehandPlan(false);
                }

                if (btnParams.planStepPath === stepNumber.SUMMARY) {
                    addPendoTracking(
                        trackingEventNames.REVIEW_PLAN,
                        btnParams.planId,
                        null
                    );
                } else {
                    addPendoTracking(
                        trackingEventNames.RESUME_PLAN,
                        btnParams.planId,
                        null
                    );
                }
                this.props.history.push(
                    Object.values(stepPath)[btnParams.planStepPath]
                );
            }
        );
    }

    async handleNotifications(planuuid) {
        let notifications = [];
        await getNotifications({
            planuuid: planuuid,
            token: this.props.authToken,
        }).then((payload) => {
            if (payload && payload.status === SUCCESS) {
                notifications = payload.changeNotificationList;
            }
        });
        return notifications;
    }

    showDownloadCard() {
        return this.props.downloadProperties.selectActive ? (
            <DownloadSelectCard
                patientuuid={this.props.downloadProperties.patientuuid}
                planuuid={this.props.downloadProperties.planuuid}
                pdfOnly={this.props.downloadProperties.pdfOnly}
            />
        ) : (
            EMPTY_STRING
        );
    }

    async checkNotification(plan) {
        const changeList = await this.handleNotifications(plan.planUuid);

        if (
            changeList === null ||
            (Array.isArray(changeList) && changeList.length === 0)
        ) {
            // Safety check: Allow plan resumption even if the change list is empty.
            // Note: The change list should now always contain at least one item, making this check
            // potentially redundant. Keeping temporarily for backward compatibility and as a fallback
            // until we can confirm the new behavior is stable across all scenarios.
            this.resumePlan(plan);
        } else {
            let notificationItemList = getNotificationList(changeList);
            this.setState({
                toggleChangeNotification: true,
                plan: plan,
                notifications: notificationItemList,
            });
        }
    }

    resumePlan(plan) {
        let path = plan.SavedData.PlanCreationStep;
        let flagState = false;

        let btnParams = {
            planId: plan.planUuid,
            patientId: plan.patientUuid,
            visitId: plan.visitUuid,
            planStepPath: path,
            flagState: flagState,
        };
        this.handleResumePlan(btnParams);
    }

    showChangeNotificationModal() {
        if (this.state.toggleChangeNotification && this.state.notifications) {
            return (
                <ChangeNotificationModal
                    titleText="Case Has Been Updated"
                    descriptionText="Please confirm to proceed to the case.
                        Proceeding will restrict others from editing this case
                        until you exit or log out."
                    proceedText="Proceed"
                    toggleOffChangeNotificationCallback={() =>
                        this.setState({
                            toggleChangeNotification: false,
                        })
                    }
                    notifications={this.state.notifications}
                    proceedBtnCallback={() => this.resumePlan(this.state.plan)}
                />
            );
        }
    }

    handleAddPatient() {
        this.props.setFlag({
            flagId: loginReducerFlags.PLAN_COMPLETED,
            newFlagState: false,
        });
        this.props.history.push(stepPath.STEP1_1);
    }

    render() {
        return (
            <div
                id="home-screen"
                className="flex h-screen w-screen flex-col overflow-hidden"
            >
                <TopBar id="top-bar-home">
                    <Link to={stepPath.HOME}>
                        <UnfoldLogo />
                    </Link>
                    <SearchBar
                        patientsFetchedData={this.state.patientsFetchedData}
                        loadComplete={this.state.loadComplete}
                        checkNotification={this.checkNotification}
                    />
                    <Button
                        id="add-patient"
                        className="mr-14 ml-2 justify-between gap-x-2 px-4 py-2 text-sm"
                        customWidth="w-auto"
                        customHeight="h-11"
                        onClick={this.handleAddPatient}
                    >
                        <PlusIcon size={17} strokeWidth={3} />
                        <span className="font-semibold">Add Patient</span>
                    </Button>
                    <ProfileMenu id="home-page-profile-menu" />
                </TopBar>
                <main className="flex-1 overflow-hidden bg-gray-100 py-3">
                    <PatientList
                        patientsFetchedData={this.state.patientsFetchedData}
                        loadComplete={this.state.loadComplete}
                        checkNotification={this.checkNotification}
                    />
                    <ProgressBar
                        loadComplete={this.state.loadComplete}
                        loadFailed={this.state.loadFailed}
                    />
                    {this.showDownloadCard()}
                    {this.showChangeNotificationModal()}
                </main>
            </div>
        );
    }
}

Home.propTypes = {
    setCurrentVisitUUID: PropTypes.func,
    setCurrentPatientUUID: PropTypes.func,
    setCurrentPlanUUID: PropTypes.func,
    useruuid: PropTypes.string,
    authToken: PropTypes.string,
    planuuid: PropTypes.string,
    resetCreatePlanShard: PropTypes.func,
    resetImageViewerShard: PropTypes.func,
    setFlag: PropTypes.func,
    setPlanCreationStepMetaData: PropTypes.func,
    history: PropTypes.object,
    downloadProperties: PropTypes.object,
    setUploadState: PropTypes.func,
    setFreehandPlan: PropTypes.func,
    setInstitutionUsersList: PropTypes.func,
    userData: PropTypes.object,
};

Home.defaultProps = {
    useruuid: EMPTY_STRING,
};

const mapStateToProps = function (state) {
    return {
        useruuid: state.LoginReducer.useruuid,
        userData: state.LoginReducer.userData,
        authToken: state.LoginReducer.authToken,
        downloadProperties: state.HomeReducer.downloadProperties,
        planuuid: state.CreatePlanReducer.planuuid,
    };
};

const mapDispatchToProps = function (dispatch) {
    return {
        setFlag: (flag) => dispatch(setFlag(flag)),
        setCurrentVisitUUID: (visituuid) =>
            dispatch(setCurrentVisitUUID(visituuid)),
        setCurrentPatientUUID: (patientuuid) =>
            dispatch(setCurrentPatientUUID(patientuuid)),
        setCurrentPlanUUID: (planuuid) =>
            dispatch(setCurrentPlanUUID(planuuid)),
        setPlanCreationStepMetaData: (stepMetaData) =>
            dispatch(setPlanCreationStepMetaData(stepMetaData)),
        setCurrentTreatmentPlan: (plan) =>
            dispatch(setCurrentTreatmentPlan(plan)),
        resetCreatePlanShard: () => dispatch(resetCreatePlanShard()),
        setFreehandPlan: (isOn) => dispatch(setFreehandPlan(isOn)),
        resetImageViewerShard: () => dispatch(resetImageViewerShard()),
        setUploadState: (idx, upstate) =>
            dispatch(setUploadState(idx, upstate)),
        setInstitutionUsersList: (institutionUsersList) =>
            dispatch(setInstitutionUsersList(institutionUsersList)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
